import { DecimalPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { CurrencySymbolComponent } from 'app/core/components/currency-symbol/currency-symbol.component';
import { CountBadgePipe } from 'app/core/pipes/badge.pipe';
import { AuthService } from '../../../../auth/auth.service';
import { DashboardEngineService } from '../../../services/dashboard-engine.service';

@Component({
  selector: 'app-risk-register',
  standalone: true,
  imports: [NgClass, RouterLink, DecimalPipe, CountBadgePipe, MatIconModule, MatProgressSpinnerModule, MatTooltipModule, CurrencySymbolComponent],
  templateUrl: './risk-register.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskRegisterComponent implements OnChanges {
  private engine = inject(DashboardEngineService);
  private auth = inject(AuthService);
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  @Input() dashboardType!: string;
  @Input() widgetId = 'riskEscalations';
  @Input() filters: any = {};
  @Input() title = 'Risk and Escalation Panel';
  @Input() requiredPermission?: string;

  get hasPermission(): boolean {
    return !this.requiredPermission || this.auth.canAccess([this.requiredPermission]);
  }

  get currencyCode(): string {
    return this.auth.profile()?.company?.currency?.currency_code || 'AED';
  }

  data: any = null;
  loading = false;
  error: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.hasPermission) return;
    if (this.dashboardType) this.fetchData();
  }

  private fetchData(): void {
    this.loading = true;
    this.engine
      .getWidgetData(this.dashboardType, this.widgetId, this.filters)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: any) => {
          this.data = res.record?.data ?? res.record ?? res;
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: (err: any) => {
          this.error = err.status === 403 ? 'Access restricted' : err.status === 500 ? 'Service unavailable' : 'Unable to load data';
          this.loading = false;
          this.cdr.markForCheck();
        },
      });
  }
}
